import {
  RawResponseTime,
  Log,
  ResponseTime,
  TimeDataMap
} from '../types';
import { logTypes } from '../utils/uptime-robot-data';
import { formatDateTime } from '../utils/format-time';

export class Checkbox {
values: {};
  constuctor(
    checked: boolean,
    label: string,
    value: string,
    onChange: void
  ) {
    this.values = {
      checked,
      label,
      value,
      onChange,
    }
    }
  }


export class Logs {
  logs: Log[];
  constructor(
    logs: Log[]
  ) {
    this.logs = logs;
  }
  getLogs() {
    return this.logs.map(log => {
      log.type = logTypes[log.type];
      log.dateTime = formatDateTime(log.datetime, true);
      return log;
    })
  }
}
export class Monitor {
  id: string;
  friendlyName: string;
  responseTimes: RawResponseTime[];
  logs: Log[];
  checked: boolean;
  type: string;
  alertCutoff: number
  constructor(
    id: number,
    friendlyName: string,
    responseTimes: RawResponseTime[],
    logs: Log[],
    type: string,
    alertCutoff: number
  ) {
    this.id = id.toString();
    this.friendlyName = friendlyName;
    this.responseTimes = responseTimes.sort((a,b) => {return a.datetime - b.datetime});
    this.logs = new Logs(logs).getLogs();
    this.checked = true;
    this.type = type;
    this.alertCutoff = alertCutoff
  }
}

export class DataMap {
  _hashTime(time: number) {
    return (Math.floor(time / 60)) * 60;
  }
  map: TimeDataMap;
  monitor: Monitor;
  constructor(monitor: any) {
    const initialKey = this._hashTime(Math.floor(Date.now() / 1000));
    this.map = {
      [initialKey]:{
        id: initialKey,
        name: '',
        datetime: 0,
        duration: 0,
      }
    }
    const { friendlyName, responseTimes, logs, type, alertCutoff } = monitor;
    this.monitor = new Monitor(monitor.monitorId, friendlyName, responseTimes, logs, type, alertCutoff);
  }

  buildMap(
    start: number,
    end: number
  ) {
    start = this._hashTime(start);
    end = this._hashTime(end);
    let i = start;
    while(i <= end) {
      const time: ResponseTime = {
        id: i,
        name: formatDateTime(i, false),
        datetime: 0,
        duration: 0,
      }
      this.map[i] = time;
      i += 60;
    }
  }

  _formatData(data: RawResponseTime[]) {
    const responseTimes = data.sort((a,b) => {
      return a.datetime - b.datetime;
    })
    return responseTimes.reduce((acc: ResponseTime[], responseTime: any) => {
      let time: ResponseTime = {
        id: this._hashTime(responseTime.datetime),
        datetime: responseTime.datetime,
        name: formatDateTime(responseTime.datetime, false),
        duration: responseTime.value,
      }
      if(responseTime.transferReceived !== undefined) {
        time.transferReceived = responseTime.transferReceived;
        time["no response yet"] = !time.transferReceived ? time.duration : null

      }
      if(responseTime.transmitFailed !== undefined) {
        time.transmitFailed = responseTime.transmitFailed
      }
      if(time.datetime <= Date.now() / 1000) {
        acc.push(time);        
      }
      return acc;
    }, [] )
  }

  populateMap(data: RawResponseTime[]) {
    const times = this._formatData(data);
    times.forEach(time => {
      
      const hash = this._hashTime(time.datetime);
      this.map[hash]
        ? this.map[hash].duration > time.duration
          ? null
          : this.map[hash] = time
        :this.map[hash] = time;
    })
  }

  updateMap(data: RawResponseTime[], startDate: number) {
    this.buildMap(
      startDate, Date.now() / 1000);
    this.populateMap(data);
    delete this.map[this.getFirstKey()];
  }

  getLongestDuration() {
    const keys = this.keys();
    return keys.reduce((acc, key) => {
      const duration = this.map[key].duration;
      acc = duration > acc ? duration : acc;
      return acc;
    }, 0)
  }

  setTransmitFailedDurationsToLongestDuration() {
    const keys = this.keys();
    keys.forEach(key => {
      const time = this.map[key];
      if(time.transmitFailed) {
        this.map[key].duration = this.getLongestDuration()
      }
    })
  }

  keys(): string[] {
    return Object.keys(this.map);
  }

  length() {
    return this.keys().length;
  }

  getFirstKey() {
    return parseInt(this.keys()[0]);
  }

  getLastKey() {
    return parseInt(this.keys()[this.keys().length -1]);
  }

  getChartData(type: string) {
    switch(type) {
      case 'bar':
        return this.keys().map(key => {
          return this.map[key];
        })
      default:
        let data: ResponseTime[] = [];
        this.keys().forEach(key => {
          if(this.map[key].transmitFailed) {
            data.push(this.map[key]);
          }
          if(this.map[key].duration !== 0) {
            data.push(this.map[key]);
          }
        })
        return data;
    }
  }
  getSubsetChartData(rangeSetting: number, type: string) {
    let dataSubset: ResponseTime[] = [];
    switch(type) {
    case 'bar':
      this.keys().forEach(key => {
        if(parseInt(key) > Math.floor(Date.now()/1000) - rangeSetting) {
          dataSubset.push(this.map[key]);
        }
      })
      return dataSubset;
    default:
      this.keys().forEach(key => {
        if(this.map[key].duration !== 0 || this.map[key].transmitFailed) {
          if(parseInt(key) > Math.floor(Date.now()/1000) - rangeSetting) {
            if(this.monitor.type === "transfer"){
              if(this.map[key].transmitFailed) {
                this.map[key].critical = 15;
              }
            }
            dataSubset.push(this.map[key]);
          }
        }
      })
      return dataSubset;
    }
  }
}



// WEBPACK FOOTER //
// ./src/classes/index.ts